import * as actionTypes from './actionTypes';

export const fetchUserPermissions = accountId => ({
  type: actionTypes.FETCH_USER_PERMISSIONS,
  accountId
});

export const fetchUserPermissionsSuccess = permissionsMap => ({
  type: actionTypes.FETCH_USER_PERMISSIONS_SUCCESS,
  permissionsMap
});

export const fetchUserPermissionsFail = () => ({
  type: actionTypes.FETCH_USER_PERMISSIONS_FAIL
});



// WEBPACK FOOTER //
// ./app/javascript/app/store/actions/entitlements.js